import { fmtDataOrigem, rotuloMovimento, temDetalhe, fmtCompCurta } from './origem';

// Resumo + "ver detalhe" da origem de uma linha do "o que mudou" (movimentações de patrimônio,
// ajuste manual, evento de contrato). Sem origem (back antigo ou erro), não renderiza nada.
const OrigemMudanca = ({ origem }) => {
    if (!origem || !origem.resumo) return null;
    const movs = origem.movimentacoes || [];
    const ajustes = origem.ajustes || [];
    const eventos = origem.eventos || [];
    return (
        <div className='mt-1 text-xs text-stone-600'>
            <div>{origem.resumo}</div>
            {temDetalhe(origem) && (
                <details className='mt-1'>
                    <summary className='cursor-pointer text-amber-800 hover:underline'>ver detalhe</summary>
                    {movs.length > 0 && (
                        <div className='overflow-x-auto mt-1'>
                            <table className='w-full min-w-[520px] border-collapse'>
                                <thead>
                                    <tr className='text-left text-amber-900'>
                                        <th className='py-1 pr-2 font-semibold'>Data</th>
                                        <th className='py-1 px-2 font-semibold'>Movimento</th>
                                        <th className='py-1 px-2 font-semibold'>Local</th>
                                        <th className='py-1 px-2 font-semibold'>Etiqueta</th>
                                        <th className='py-1 px-2 font-semibold'>Técnico</th>
                                        <th className='py-1 pl-2 font-semibold'>Chamado</th>
                                    </tr>
                                </thead>
                                <tbody className='divide-y divide-amber-100'>
                                    {movs.map((m) => (
                                        <tr key={m.id}>
                                            <td className='py-1 pr-2 whitespace-nowrap'>{fmtDataOrigem(m.data)}</td>
                                            <td className='py-1 px-2 whitespace-nowrap'>{rotuloMovimento(m)}</td>
                                            <td className='py-1 px-2'>{m.local || '—'}</td>
                                            <td className='py-1 px-2 whitespace-nowrap'>{m.etiqueta || '—'}</td>
                                            <td className='py-1 px-2 whitespace-nowrap'>{m.tecnico || '—'}</td>
                                            <td className='py-1 pl-2 whitespace-nowrap'>{m.chamado ? `#${m.chamado}` : '—'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {origem.total_movimentacoes > movs.length && (
                                <div className='mt-1 italic'>Mostrando as primeiras {movs.length} de {origem.total_movimentacoes} movimentações.</div>
                            )}
                        </div>
                    )}
                    {ajustes.length > 0 && (
                        <ul className='mt-1 list-disc pl-4'>
                            {ajustes.map((a) => (
                                <li key={`aj-${a.competencia}`}>
                                    Ajuste manual da quantidade para {a.quantidade} na competência {fmtCompCurta(a.competencia)}
                                    {a.autor ? `, por ${a.autor}` : ''}{a.data ? ` em ${fmtDataOrigem(a.data)}` : ''}
                                </li>
                            ))}
                        </ul>
                    )}
                    {eventos.length > 0 && (
                        <ul className='mt-1 list-disc pl-4'>
                            {eventos.map((e, i) => (
                                <li key={`ev-${i}`}>Contrato: {e.rotulo} de {fmtDataOrigem(e.data)}</li>
                            ))}
                        </ul>
                    )}
                </details>
            )}
        </div>
    );
};

export default OrigemMudanca;
